/**
 * 予実管理の既定の期間（FY27 = 2026-07-01〜2027-06-30）。
 *
 * 期間の開始日・終了日を省略したときに使う。Hub API（`/budget-actual/targets` と `/budget-actual/offer-breakdown` が
 * 省略された端に当てる）と画面（オファーの内訳を取る前に欠けた端を埋め、計測開始前の期間なら API を呼ばない）が
 * 同じ値を使う。片方だけで持つと、画面が埋めた期間と API が当てた期間が食い違うため、ここを唯一の正本にする。
 *
 * @graph-stack ac-mens-hub
 * @graph-domain Finance
 * @graph-business 予実管理の期間を省略したときの既定の開始日・終了日を、Hub API と画面で共有する
 * @graph-connects none
 */
/**
 * 予実管理の既定期間の開始日（FY27 Q1 の初日）。
 * @graph-stack ac-mens-hub
 * @graph-domain Finance
 * @graph-business 予実管理の期間の開始日を省略したときの既定値を定義する
 * @graph-connects none
 */
export const BUDGET_ACTUAL_DEFAULT_FROM = '2026-07-01';
/**
 * 予実管理の既定期間の終了日（FY27 Q4 の最終日）。
 * @graph-stack ac-mens-hub
 * @graph-domain Finance
 * @graph-business 予実管理の期間の終了日を省略したときの既定値を定義する
 * @graph-connects none
 */
export const BUDGET_ACTUAL_DEFAULT_TO = '2027-06-30';
//# sourceMappingURL=budget-actual-period.js.map